"use Client";
import React from 'react';
import Select from 'react-select';
import styles from './CustomSelect.module.scss';

const CustomSelect = ({ field, form, options, placeholder, showError, sx, label, width }) => {
  const handleChange = (selectedOption) => {
    form.setFieldValue(field.name, selectedOption?.value);
  };
  return (
    <div className={styles.customSelectContainer}
      style={{ width: width ?? '100%' }}
    >
      {label && (
        <div className={styles.label}>
          <label>{label}</label>
        </div>
      )}
      {showError !== true && form?.errors[`${field?.name}`] && (
        <div className={styles.errorMessage}>{form?.errors[`${field?.name}`]}</div>
      )}
      <div className={styles.inputWrapper}>
        <Select
        instanceId="custom-select1"
          {...field}
          className={styles.customSelect}
          value={options?.find(option => option?.value === field?.value) || ''}
          onChange={handleChange}
          options={options}
          placeholder={placeholder ?? 'Select an option'}
          styles={sx}
        />
      </div>
    </div>
  );
};

export default CustomSelect;